<template>
    <div class="pop" v-show="show"  @click.stop='_=>{}'>
        <div class="box">
            <div class="title">
                <span @click="show = false" class="closeBtn"></span>
            </div>
            <div class="wrap">
                <h2>报名人数已满，预约下次培训班</h2>
                <p>请留下联系方式，我们会在下次开课时第一时间通知你</p>
                <div class="line nessasery">
                    <label>姓名：</label>
                    <input type="text" v-model="name">
                </div>
                <div class="line nessasery">
                    <label>电话：</label>
                    <input type="text" v-model="phone">
                </div>

                <div class="line nessasery">
                    <label>地址：</label>
                    <select v-model='provinceId'>
                        <option :value="item" v-for='(item,index) in province' :key='index'>
                            {{item.regioN_NAME}}</option>
                    </select>
                    <select v-model='cityId' style='margin-left:18px;' >
                        <option :value="item" v-for='(item,index) in city' :key='index'>
                            {{item.regioN_NAME}}</option>
                    </select>
                </div>
                <p style="height:16px;text-align:center;color:red;">{{msg}}</p>
                <button class="roger" @click="sub">{{status ? '确定' : '提交'}}</button>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    // @ is an alias to /src

    export default {
        name: 'alert',
        data: () => ({
            show: true,
            province: [{regioN_ID: null,regioN_NAME: "--省份--"}],
            provinceId: '',
            city: [{regioN_ID: null,regioN_NAME: "--城市--"}],
            cityId: '',
            name: '',
            phone: '',
            msg: '',
            status: null
        }),
        props: {
            content: {
                default: '',
                type: String
            },
            confirmCall: {
                default: () => {},
                type: Function
            }
        },
        methods: {
            close() {
                this.show = false
            },
            sub () {
                if(this.status) {
                    this.close()
                    return
                }
                axios({
                    url: '/api/Product/AddCusInfo?name='+this.name+'&tel='+this.phone+'&city=' + this.cityId.regioN_NAME + '&province=' + this.provinceId.regioN_NAME ,
                    method: 'get'
                }).then(res => {
                    // this.close()
                    this.status = res.data.status
                    this.msg = res.data.message
                })
            }
        },
        components: {

        },
        watch: {
            provinceId (val) {
                axios({
                    url: '/api/Order/GetProv?type=2&id=' + val.regioN_ID,
                    method: 'get'
                }).then(res => {
                    this.city = [{regioN_ID: null,regioN_NAME: "--城市--"}].concat(res.data)
                })
            }
        },
        mounted() {
            axios({
                url: '/api/Order/GetProv?type=1',
                method: 'get'
            }).then(res => {
                this.province = [{regioN_ID: null,regioN_NAME: "--省份--"}].concat(res.data)
            })
        }
    }
</script>

<style scoped>
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .line {
        width: 300px;
        margin: 0 auto;
        margin-bottom: 10px;
    }

    .line label {
        width: 60px;
        display: inline-block;
    }

    .line input {
        width: 200px;
        height: 26px;
        outline: none;
        border: 1px solid #999;
        border-radius: 3px;
    }

    .line select {
        width: 94px;
        height: 26px;
        outline: none;
        border: 1px solid #999;
        border-radius: 3px;
    }

    .box {
        width: 494px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) no-repeat;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
    }

    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 30px 60px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
    }

    .wrap h2 {
        font-size: 18px;
        padding: 0;
        padding-left: 30px;
        margin: 0;
        background: url(../assets/image/tanhao1.png) no-repeat left center;
    }

    .wrap p {
        padding: 0;
        margin: 0;
        font-weight: normal;
        margin-bottom: 20px;
    }

    .roger {
        color: #fff;
        font-weight: bolder;
        background: rgb(73, 132, 212);
        padding: 5px 28px;
        cursor: pointer;
        display: block;
        width: 96px;
        zoom: 1;
        margin: 0 auto;
        border: 0;
        margin-top: 25px;
        outline: 0;
    }
    .closeBtn {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(../assets/image/close.png) no-repeat center;
        background-size: 12px;
        cursor: pointer;
    }
</style>